var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tab-bar-item",on:{"click":function($event){return _vm.itemClick()}}},[_c('div',[_vm._t("item-icon")],2),_c('div',[_vm._t("item-text")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }